import Lottie from "lottie-react";

import styled from "styled-components";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

export const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  backdrop-filter: blur(5px);
`;

export const ModalContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30%;
  height: 350px;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 1024px) {
    width: 50%;
    height: 60vh;
  }
  @media screen and (max-width: 999px) {
    width: 70%;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
`;

export const StyledLottie = styled(Lottie)`
  width: 90%;
  height: 50%;
`;

export const ConfettiHeader = styled.h3`
  display: flex;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  color: ${colors.NAVYBLUE};
  margin-top: 0;
`;

export const AccountInfo = styled.p`
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  text-align: center;
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  color: #868686;
  margin-top: 0;
`;
